<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                "업계 최대 200만 가맹점 네트워크" <br />
                한국정보통신 <strong class="c-red">IT본부</strong>
            </h1>
            <p>
                한국정보통신 IT본부는 업계 최대 200만 네트워크를 구축하고 최첨단 IDC 센터와 최적의 보안시스템을 통해 가장 안전한 서비스를 제공하고
                있습니다. <br />
                30년 이상 축적된 노하우를 바탕으로 카드사, 은행, 통신사 등 대외 인터페이스에서 최고의 기술력을 보유하고 있으며<br />
                포스시스템 솔루션, 온라인 결제 솔루션, 스마트폰 결제 솔루션 등 새로운 사업분야를 연구개발하며 기술력을 확장하고 있습니다.<br />
                <br />
                IT본부는 시스템의 안정적인 운영을 책임지는 정보시스템팀과 IT기획보안팀, 대외 인터페이스 및 시스템 개발을 위한 프로그램 분석과 설계를
                담당하는 <br class="pc-only"/>
                VAN서비스팀과 온라인서비스팀, 스마트한 오프라인 결제 솔루션을 개발하는 POS솔루션팀으로 구성되어 있습니다.
            </p>
            <img src="@/assets/it_image01.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>
